// import {
//     GET_PRODUCT_LIST,
//     GET_CART_LIST,
//     ADD_PRODUCT_TO_CART,
//     DELETE_PRODUCT_FROM_CART,
//     UPDATE_CART_AMOUNT,
//     GET_CATEGORY_LIST,
//     GET_RATING_LIST,
//     GET_BRAND_LIST,
// } from '../actions/EcommerceActions'

// const initialState = {
//     productList: [],
//     cartList: [],
// }

// const EcommerceReducer = function (state = initialState, action) {
//     switch (action.type) {
//         case GET_PRODUCT_LIST: {
//             return {
//                 ...state,
//                 productList: [...action.payload],
//             }
//         }
//         case GET_CATEGORY_LIST: {
//             return {
//                 ...state,
//                 categoryList: [...action.payload],
//             }
//         }
//         case GET_RATING_LIST: {
//             return {
//                 ...state,
//                 ratingList: [...action.payload],
//             }
//         }
//         case GET_BRAND_LIST: {
//             return {
//                 ...state,
//                 brandList: [...action.payload],
//             }
//         }
//         case GET_CART_LIST: {
//             return {
//                 ...state,
//                 cartList: [...action.payload],
//             }
//         }
//         case ADD_PRODUCT_TO_CART: {
//             return {
//                 ...state,
//                 cartList: [...action.payload],
//             }
//         }
//         case DELETE_PRODUCT_FROM_CART: {
//             return {
//                 ...state,
//                 cartList: [...action.payload],
//             }
//         }
//         case UPDATE_CART_AMOUNT: {
//             return {
//                 ...state,
//                 cartList: [...action.payload],
//             }
//         }
//         default: {
//             return {
//                 ...state,
//             }
//         }
//     }
// }

// export default EcommerceReducer

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  productList: [],
  cartList: [],
  categoryList: [],
  ratingList: [],
  brandList: [],
};

const ecommerceSlice = createSlice({
  name: 'ecommerce',
  initialState,
  reducers: {
    getProductList(state, action) {
      state.productList = action.payload;
    },
    getCategoryList(state, action) {
      state.categoryList = action.payload;
    },
    getRatingList(state, action) {
      state.ratingList = action.payload;
    },
    getBrandList(state, action) {
      state.brandList = action.payload;
    },
    getCartList(state, action) {
      state.cartList = action.payload;
    },
    addProductToCart(state, action) {
      state.cartList = action.payload;
    },
    deleteProductFromCart(state, action) {
      state.cartList = action.payload;
    },
    updateCartAmount(state, action) {
      state.cartList = action.payload;
    },
  },
});

export const {
  getProductList,
  getCategoryList,
  getRatingList,
  getBrandList,
  getCartList,
  addProductToCart,
  deleteProductFromCart,
  updateCartAmount,
} = ecommerceSlice.actions;

export default ecommerceSlice.reducer;
